// src/shared/hooks/useFetch.js
// hook عام لجلب البيانات — يُستخدم كأساس لبقية الـ hooks
import { useState, useEffect, useCallback } from 'react';

/**
 * @param {Function} apiFn      - الدالة من طبقة API (مثل fetchBookings)
 * @param {Array}    deps       - المتغيرات التي تُعيد الجلب عند تغيرها
 * @param {boolean}  immediate  - هل يجلب فوراً عند التحميل؟ (افتراضي: true)
 */
const useFetch = (apiFn, deps = [], immediate = true) => {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(immediate);
  const [error, setError]     = useState(null);

  const execute = useCallback(async (...args) => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiFn(...args);
      setData(response.data);
      return response.data;
    } catch (err) {
      const message =
        err.response?.data?.detail ||
        err.response?.data?.error  ||
        'حدث خطأ غير متوقع.';
      setError(message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [apiFn]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (immediate) {
      execute();
    }
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps

  return { data, loading, error, execute, setData };
};

export default useFetch;